import styled from 'styled-components';
import { animated } from 'react-spring';

export const InvoiceProofCSS = styled(animated.div)`
  padding: 0.5rem 0;
  overflow: hidden;
  margin-bottom: 1.5rem;
`;
